export const arr1 = [
  { text: 'По числовой последовательности можно восстановить звуковую волну. Для этого нужен обратный процесс:' },
  { text: '1) Сначала восстанови уровни звука на каждом участке по его числовому значению. Для этого подними подсвеченные планки внизу экрана к их числовым значениям. ', buttonTitle: 'Продолжить' },
]

export const arr2 = [
  { text: '2) Затем по уровням восстанавливается кривая звуковой волны.' },
  { text: 'Важно понимать: качество оцифрованной волны всегда хуже, чем оригинального аналогового сигнала. Поэтому важно выбирать частоту дискретизации таким образом, чтобы качество результата было приемлемым.' },
  { text: 'Можешь прослушать, что получилось.' },
  { text: 'Разница, конечно, есть, но теперь ты знаешь, как оцифровать с лучшим качеством.', buttonTitle: 'Продолжить' },
]

export const task = [
  { text: '1) Сначала восстанови уровни звука на каждом участке по его числовому значению. Для этого подними подсвеченные планки внизу экрана к их числовым значениям.' },
]
